export class CalendarFormSubmission {
  HideEventType: boolean;
  RequireLogin: boolean;
  CalendarType: number;
  PageTitle: string;
  SettingBatch?: string;
  ConfirmationMessage: string;

  public constructor() {
    this.HideEventType = false;
    this.RequireLogin = false;
    this.CalendarType = 0;
    this.PageTitle = '';
    this.ConfirmationMessage = '';
  }
}
